import { DataHubActions } from '../../dataHubActions';
import { BaseViewSchema } from '../baseViewSchema';
export class ViewBulkPublishSchema extends BaseViewSchema {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: DataHubActions.ViewBulkPublish
        });
    }
    getDataHubEventData() {
        return super.prepare();
    }
}
